// For now operating only on width works nice for us
export const imageUrlForSize = (bareUrl, width) => `${bareUrl}?w=${width}`;

export const lowQualityImageUrlForSize = (bareUrl, width) => `${bareUrl}?w=${width}&q=10`;
